module.exports = __webpack_public_path__ + "img/Amber-M.207f260d.png";